import config from "../../../config/config"
import { GetTournamentMembersUseCase } from "../../../domain/useCases/tournamentMembers/getTournamentMembers"
import { DownloadTournamentMembersUseCase } from "../../../domain/useCases/tournamentMembers/downloadTournamentMembers"
import { action, makeObservable, observable } from "mobx"
import { TournamentMember } from "../../../domain/entities/TournamentMember"
import { ApiErrorCodes, ErrorHandler } from "../../error/ErrorHandler"
import { TableConfig } from "../../components/DataTable/types/TableConfig"
import { FileService } from "../../../domain/services/FileService"

interface ContructorParams {
	GetTournamentMembersUseCase: GetTournamentMembersUseCase
	DownloadTournamentMembersUseCase: DownloadTournamentMembersUseCase
	ErrorHandler: ErrorHandler
}

export class TournamentMembersViewModel {
	private _getTournamentMembersUseCase
	private _downloadTournamentMembersUseCase
	private _errorHandler
	isLoading: boolean = false
	isFetching: boolean = false
	isDownloading: boolean = false
	tournamentMembers: Partial<TournamentMember>[] = []
	tournamentId: number = 0
	tableConfig: TableConfig = {
		pageSize: config.ui.componentsConfig.dataTablePageSize,
		sort: { order: "descend", field: "id" }
	}

	constructor({ GetTournamentMembersUseCase, DownloadTournamentMembersUseCase, ErrorHandler }: ContructorParams) {
		makeObservable(this, {
			isLoading: observable,
			isFetching: observable,
			isDownloading: observable,
			tournamentMembers: observable,
			tournamentId: observable,
			setLoading: action,
			setIsFetching: action,
			setIsDownloading: action,
			setTournamentMembers: action,
			setTournamentId: action,
			tableConfig: observable,
			setTableConfig: action
		})
		this._getTournamentMembersUseCase = GetTournamentMembersUseCase
		this._downloadTournamentMembersUseCase = DownloadTournamentMembersUseCase
		this._errorHandler = ErrorHandler
	}

	public async fetchTournamentMembers(tournamentId: number) {
		this.setLoading(true)
		this.setTournamentId(tournamentId)
		try {
			const members = await this._getTournamentMembersUseCase.exec({ serviceId: tournamentId })
			this.setTournamentMembers(members)
		} catch (error) {
			throw this._errorHandler.handleError(error)
		} finally {
			this.setLoading(false)
		}
	}

	public async downloadTournamentMembers() {
		this.setIsDownloading(true)
		try {
			const file = await this._downloadTournamentMembersUseCase.exec({ serviceId: this.tournamentId })
			const fileService = new FileService()
			fileService.dowloadFile(file, `Miembros_Torneo_${this.tournamentId}.csv`)
		} catch (error) {
			throw this._errorHandler.handleError(error)
		} finally {
			this.setIsDownloading(false)
		}
	}

	setTournamentMembers(members: Partial<TournamentMember>[]) {
		this.tournamentMembers = members
	}

	setLoading(loading: boolean) {
		this.isLoading = loading
	}

	setIsFetching(loading: boolean) {
		this.isFetching = loading
	}

	setIsDownloading(downloading: boolean) {
		this.isDownloading = downloading
	}

	setTournamentId(tournamentId: number) {
		this.tournamentId = tournamentId
	}

	setTableConfig(config: Partial<typeof this.tableConfig>) {
		this.tableConfig = { ...this.tableConfig, ...config }
	}
}
